import { Button, Grid2, TextField } from '@mui/material'
import React from 'react'
import Heading from '../../shared/utils/Heading'



const SubscribeSection = () => {
    return (
        <Grid2 container spacing={2} sx={{display:"flex",alignItems:"center"}}>
            <Grid2 children size={{ xs: 12, lg: 7 }}>
                <Heading Heading={"Get the latest news, updates, and exclusive offers delivered to your inbox!"} SubHeading={"Stay Updated with Our Newsletter!"} />
            </Grid2>
            <Grid2 container size={{ xs: 12, lg: 3.5 }} sx={{display:"flex",justifyContent:"start",flexDirection:{xs:"row",md:"column"}}}>
                <Grid2 children size={{ xs: 7, md: 12 }}>
                    <TextField
                        placeholder='Enter Your Mail ID'
                        fullWidth
                        sx={{
                            border: "0.5px solid #DC143C",
                            borderRadius: "12px",
                            "& fieldset": { border: "none" },
                            mb: 2,
                            py: { xs: "0px", sm: "0px" },
                            display: "flex",
                            alignItems: "center",
                            "& .MuiInputBase-input": {
                                typography: "body1",
                                padding: "10px 10px"

                            }
                        }}
                    />
                </Grid2>
                <Grid2 children size={{ xs: 4, md: 12 }}>     <Button variant='contained' fullWidth>Subscribe</Button></Grid2>

            </Grid2>

        </Grid2>
    )
}

export default SubscribeSection